// Auth context for Propulse Learning Academy
import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, setToken, getToken } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getToken();
        if (!token) {
            setLoading(false);
            return;
        }
        api.get('/auth/me')
            .then((r) => setUser(r.data))
            .catch(() => setToken(null))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post('/auth/register', payload);
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        setToken(null);
        setUser(null);
    };

    const refresh = async () => {
        const { data } = await api.get('/auth/me');
        setUser(data);
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);

export const isAdmin = (user) => {
    if (!user) return false;
    return [
        'super_admin', 'company_admin', 'learning_manager', 'department_manager',
        'hr_admin', 'trainer', 'compliance_officer', 'regional_manager', 'branch_manager',
    ].includes(user.role);
};
